import { FC, PropsWithChildren, useEffect, useRef, useState } from 'react';
import Header from './_parts/header/Header';
import classNames from 'classnames';
import with_user_role, { IWithUserRoleProps } from '../../hocs/main/WithUserRole';
import { UserRoleEnum } from '../../../enums/user';
import Footer from './_parts/footer/Footer';
import FooterSection, { FooterSectionProps } from '../../../components/sections/FooterSection/FooterSection';
import SectionDivider from '../../../components/sections/SectionDivider/SectionDivider';
import MainButton from '../../../components/buttons/MainButton/MainButton';
import API from '../../../api/index';
import { useAppSelector } from '../../../redux/hooks';
import RoutesEnum from '../../../enums/routes';
import { Params, useLocation, useNavigate, useNavigation, useParams } from 'react-router-dom';
import HeaderBar from './_parts/HeaderBar/HeaderBar';
import StartupSection from '../../../components/sections/StartupSection/StartupSection';
import styles from './MainTemplate.module.scss';
import WhatIsAstronomicPopUp from '../../../components/popups/WhatIsAstronomicPopUp/WhatIsAstronomicPopUp';
import { GENERAL_CONTENT } from '../../../data/generalContent';

interface MainTemplateForHomeViewProps
  extends PropsWithChildren,
    IWithUserRoleProps,
    Pick<FooterSectionProps, 'footerSectionVariation'> {
  color?: 'white' | 'blue';
  flashRoleSelector?: boolean;
  user_role: UserRoleEnum;
  handleRoleChange?(): void;
}

const MainTemplateForHomeView: FC<MainTemplateForHomeViewProps> = ({
  children,
  color = 'blue',
  footerSectionVariation = 'var-0',
  user_role,
  flashRoleSelector,
  router,
  handleRoleChange,
}) => {
  const isUserLoggedIn = useAppSelector((state) => state.user.userLogged);
  const navigate = useNavigate();
  const [startAnimation, setStartAnimation] = useState<Boolean>(false);

  // const headerRef = useRef<HTMLElement>(null);
  // const headerBarRef = useRef<HTMLElement>(null);

  const [isPopUpActive, setIsPopUpActive] = useState(false);

  const togglePopUp = () => {
    setIsPopUpActive(!isPopUpActive);
  };

  return (
    <div
      className={classNames(
        styles['main-template'],
        startAnimation && styles['main-template--startup-animation-active'],
        'template main-template'
      )}
    >
      <HeaderBar setStartAnimation={setStartAnimation} userRole={user_role} />

      <Header
        user_role={user_role}
        headerColor={color}
        loggedIn={isUserLoggedIn}
        flashRoleSelector={flashRoleSelector}
      />

      <main>
        <StartupSection
          title="Your one-stop startup shop for"
          text=""
          userRole={user_role}
          startAnimation={startAnimation}
          setStartAnimation={setStartAnimation}
          handleRoleChange={handleRoleChange}
          buttonGroup={[
            isUserLoggedIn === false ? (
              <MainButton
                sizeType={'large'}
                visualType="main"
                onClick={() => {
                  navigate(`/${RoutesEnum.SIGN_UP}`);
                }}
              >
                {GENERAL_CONTENT.JOIN_ASTRONOMIC_FOR_FREE}
              </MainButton>
            ) : (
              <MainButton
                sizeType={'large'}
                visualType="main"
                onClick={() => {
                  navigate(`/${user_role}/${RoutesEnum.SCHEDULE_MEETING}`);
                }}
              >
                {GENERAL_CONTENT.SCHEDULE_A_MEETING}
              </MainButton>
            ),
            <MainButton sizeType={'large'} visualType="blank" onClick={togglePopUp}>
              {GENERAL_CONTENT.HOW_ASTRONOMIC_WORKS}
            </MainButton>,
          ]}
        />

        {startAnimation === false && (
          <>
            {children}

            <SectionDivider color="blue" />

            <FooterSection
              title="No one goes to the moon alone"
              text="Astronomic is your copilot for accelerating every step of your journey to the moon."
              buttonGroup={[
                isUserLoggedIn === false ? (
                  <MainButton
                    sizeType={'large'}
                    visualType="main"
                    onClick={() => {
                      router.navigate(`/${RoutesEnum.SIGN_UP}`);
                    }}
                  >
                    Join Astronomic for free
                  </MainButton>
                ) : (
                  <MainButton
                    sizeType={'large'}
                    visualType="main"
                    onClick={() => {
                      router.navigate(`/${user_role}/${RoutesEnum.SCHEDULE_MEETING}`);
                    }}
                  >
                    Schedule a meeting
                  </MainButton>
                ),
                <MainButton
                  sizeType={'large'}
                  visualType="blank"
                  onClick={() => {
                    router.navigate(`/${user_role}/${RoutesEnum.ABOUT}`);
                  }}
                >
                  About Us
                </MainButton>,
              ]}
              footerSectionVariation={footerSectionVariation}
            />
          </>
        )}

        <WhatIsAstronomicPopUp
          whatIsPopUpActive={isPopUpActive}
          changeWhatIsPopUpActiveState={togglePopUp}
          userRole={user_role}
        />
      </main>

      {startAnimation === false && <Footer userRole={user_role} />}
    </div>
  );
};

export default with_user_role(MainTemplateForHomeView);
